import { FormInstance } from "antd";
import { useCallback } from "react";

export const useCompleteStep = (
  form: FormInstance,
  setStep: React.Dispatch<React.SetStateAction<number>>,
  setRequest: React.Dispatch<React.SetStateAction<any>>,
) => {
  const onNext = useCallback(async () => {
    try {
      const values = await form.validateFields();
      setStep((prev) => prev + 1);
      setRequest((prev: any) => ({ ...prev, ...values }));
    } catch {}
  }, [form, setStep, setRequest]);

  return { onNext };
};
